import React, { useRef } from "react";
import {
  Box,
  Button,
  Fab,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { currencyFormat } from "../../../../components/NewDetail/calculations/utils";
import moment from "moment";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";

const PrintSalesMenuItem = ({ onClick, salesTicket, ...props }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  if (salesTicket)
    return (
      <>
        <MenuItem
          disableRipple
          // disabled={
          //   !quote.orderStatus ||
          //   quote.orderStatus.name !== "QUOTE_REQUESTED"
          // }
          onClick={() => {
            onClick();
            handlePrint();
          }}
        >
          <PrintIcon sx={{ marginRight: "8px" }} />
          Print Sales Ticket
        </MenuItem>
        <div style={{ display: "none" }}>
          <div ref={componentRef}>
            <div
              style={{
                margin: "32px",
                backgroundColor: "#fff",
                color: "#000",
                position: "relative",
                breakInside: "avoid",
                breakBefore: "always",
                breakAfter: "always",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <img
                    style={{ marginTop: "8px", marginBottom: "8px" }}
                    src="/industry-metal-co-long-logo.png"
                    height={50}
                  />
                </Box>
                <Typography variant="h4" textAlign="center">
                  Sales Ticket #{salesTicket.id}
                </Typography>
              </Box>

              <Box>
                <Box sx={{ marginTop: "16px" }}>
                  <Typography variant="h6">Details</Typography>
                  <Box sx={{ padding: "16px" }}>
                    {!salesTicket.isNotAnIndustryCustomer && (
                      <Typography>
                        Customer: {salesTicket.company.name}
                      </Typography>
                    )}

                    <Typography>
                      Created On:{" "}
                      {moment(salesTicket.created_at).format("MM/DD/YY")}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ marginTop: "16px" }}>
                  <Typography variant="h6">Items</Typography>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Description</TableCell>
                          <TableCell align="left">UOM</TableCell>
                          <TableCell align="left">Quantity</TableCell>
                          <TableCell align="left">Price</TableCell>
                          <TableCell align="left">Item Total Price</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {salesTicket.salesTicketItems.map(
                          (salesTicketItem, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell align="left">
                                  {salesTicketItem.description}
                                </TableCell>
                                <TableCell align="left">
                                  {salesTicketItem.uom}
                                </TableCell>
                                <TableCell align="left">
                                  {salesTicketItem.quantity ?? 0}
                                </TableCell>
                                <TableCell align="left">
                                  {currencyFormat(
                                    salesTicketItem.unitPrice ?? 0
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  {currencyFormat(
                                    salesTicketItem.totalPrice ?? 0
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}
                      </TableBody>
                    </Table>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "16px",
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {salesTicket.status == "Paid" && (
                          <img
                            style={{}}
                            src="/paid-watermark.png"
                            height={175}
                          />
                        )}
                      </Box>
                      <Box
                        sx={{
                          width: "200px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            textAlign: "left",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          Subtotal:{" "}
                          {currencyFormat(salesTicket.subTotalPrice ?? 0)}
                        </Typography>
                        <Typography variant="h6" sx={{ textAlign: "left" }}>
                          Sales Tax:{" "}
                          {currencyFormat(salesTicket.totalSalesTax ?? 0)}
                        </Typography>
                        <Typography variant="h5" sx={{ textAlign: "left" }}>
                          Total: {currencyFormat(salesTicket.totalPrice ?? 0)}
                        </Typography>
                      </Box>
                    </Box>
                  </TableContainer>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </>
    );
};

export default PrintSalesMenuItem;
